import { render, staticRenderFns } from "./TopicDetailDialog.vue?vue&type=template&id=2aa8d967&scoped=true"
import script from "./TopicDetailDialog.vue?vue&type=script&lang=js"
export * from "./TopicDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TopicDetailDialog.vue?vue&type=style&index=0&id=2aa8d967&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8d967",
  null
  
)

export default component.exports